/* eslint-disable no-unused-vars */
import React, {
  memo, useContext, useEffect, useMemo, useState,
} from 'react';
import {
  Alert, Badge, Col, Collapse, Container, InputGroup, ListGroup, Row, Table,
} from 'react-bootstrap';
import useLister, { useDict, useFilterItems } from '../../BaseLister/hook';
import { EditorControls } from '../../BasicEditor/editorControls';
import { Loader } from '../../../components/Styled/Misc';
import AppContext from '../../../providers/authProvider';
import api from '../../../api/req';
import DocumentReportRow from './row';
import { Selector } from '../../../components/Controls';
import LoaderContainer from '../../DashBoard/LoaderContainer';

const API_URL = '/api/documents/';

const BOOL_CHOICES = [
  { value: true, display_name: 'Yes' },
  { value: false, display_name: 'No' },
];
function DocumentsReport() {
  const {
    data, fields, onNextPage, onPrevPage,
    setErr, loading, err, canNextPage, canPrevPage,
    onSetFilter, filter, count,
  } = useLister({ url: API_URL, initialFilter: { is_expired: true } });

  const docTypes = useDict({ url: '/api/cat/document_type/' });
  const docCats = useDict({ url: '/api/cat/document_category/' });

  const expiredFilter = useFilterItems(filter, 'is_expired', onSetFilter);
  const dangerFilter = useFilterItems(filter, 'is_danger', onSetFilter);
  const warningFilter = useFilterItems(filter, 'is_warning', onSetFilter);
  const docTypeFilter = useFilterItems(filter, 'document_type', onSetFilter);
  const docCatFilter = useFilterItems(filter, 'document_category', onSetFilter);
  return (
    <LoaderContainer
      onPrevPage={onPrevPage}
      canPrev={canPrevPage}
      onNextPage={onNextPage}
      canNext={canNextPage}
      setErr={setErr}
      loading={loading}
      err={err}
    >
      <Container fluid>
        <div className="d-inline-flex align-items-start">
          <h1>
            Documents report
          </h1>
          <Badge>{count}</Badge>
        </div>
        {loading && <Loader />}
        {err && <Alert variant="danger">{err}</Alert>}
        <Row>
          <Col lg={8} xl={9}>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Document type</th>
                  <th>Document category</th>
                  <th>Canidate</th>
                  <th>Date of Issue</th>
                  <th>Issuer</th>
                  <th>Valid to</th>
                  <th>Download document</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <DocumentReportRow row={row} key={row.id} />
                ))}
              </tbody>
            </Table>
          </Col>
          <Col lg={4} xl={3}>
            <div>
              <h3>Filters</h3>
              <ListGroup>
                <ListGroup.Item>
                  <Selector
                    prepend={(
                      <>
                        <InputGroup.Text>{fields.expired?.label}</InputGroup.Text>
                        <InputGroup.Checkbox checked={expiredFilter.use} onChange={expiredFilter.onToggle} />
                      </>
                      )}
                    value={expiredFilter.value}
                    onChange={expiredFilter.onChange}
                    values={BOOL_CHOICES}
                    required
                  />
                </ListGroup.Item>
                <ListGroup.Item>
                  <Selector
                    prepend={(
                      <>
                        <InputGroup.Text>{fields.danger?.label}</InputGroup.Text>
                        <InputGroup.Checkbox checked={dangerFilter.use} onChange={dangerFilter.onToggle} />
                      </>
                      )}
                    value={dangerFilter.value}
                    onChange={dangerFilter.onChange}
                    values={BOOL_CHOICES}
                    required
                  />
                </ListGroup.Item>
                <ListGroup.Item>
                  <Selector
                    prepend={(
                      <>
                        <InputGroup.Text>{fields.warning?.label}</InputGroup.Text>
                        <InputGroup.Checkbox checked={warningFilter.use} onChange={warningFilter.onToggle} />
                      </>
                      )}
                    value={warningFilter.value}
                    onChange={warningFilter.onChange}
                    values={BOOL_CHOICES}
                    required
                  />
                </ListGroup.Item>
                <ListGroup.Item>
                  <Selector
                    prepend={(
                      <>
                        <InputGroup.Text>{fields.document_type?.label}</InputGroup.Text>
                        <InputGroup.Checkbox checked={docTypeFilter.use} onChange={docTypeFilter.onToggle} />
                      </>
                      )}
                    value={docTypeFilter.value}
                    onChange={docTypeFilter.onChange}
                    values={docTypes.selectorValues}
                    required
                  />
                </ListGroup.Item>
                <ListGroup.Item>
                  <Selector
                    prepend={(
                      <>
                        <InputGroup.Text>{fields.document_category?.label}</InputGroup.Text>
                        <InputGroup.Checkbox checked={docCatFilter.use} onChange={docCatFilter.onToggle} />
                      </>
                      )}
                    value={docCatFilter.value}
                    onChange={docCatFilter.onChange}
                    values={docCats.selectorValues}
                    required
                  />
                </ListGroup.Item>
              </ListGroup>
            </div>
          </Col>
        </Row>
      </Container>
    </LoaderContainer>
  );
}

export default memo(DocumentsReport);
